module.exports = __webpack_public_path__ + "img/security_code.9c15fbbd.png";